import(/* webpackMode: "eager" */ "/usr/src/app/components/Footer/footer.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/components/Icons/icons.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/components/Navbar/index.tsx");
